import { Data, Params } from '@angular/router';
import { getRouterSelectors } from '@ngrx/router-store';
import { MemoizedSelector } from '@ngrx/store';

export const {
  selectCurrentRoute, // select the current route
  selectFragment, // select the current route fragment
  selectQueryParams, // select the current route query params
  selectQueryParam, // factory function to select a query param
  selectRouteParams, // select the current route params
  selectRouteParam, // factory function to select a route param
  selectRouteData, // select the current route data
  selectUrl, // select the current url
}: {
  selectCurrentRoute: MemoizedSelector<Record<string, any>, any>;
  selectFragment: MemoizedSelector<Record<string, any>, string | undefined>;
  selectQueryParams: MemoizedSelector<Record<string, any>, Params>;
  selectQueryParam: (
    param: string,
  ) => MemoizedSelector<Record<string, any>, string | string[] | undefined>;
  selectRouteParams: MemoizedSelector<Record<string, any>, Params>;
  selectRouteParam: (
    param: string,
  ) => MemoizedSelector<Record<string, any>, string | undefined>;
  selectRouteData: MemoizedSelector<Record<string, any>, Data>;
  selectRouteDataParam: (
    param: string,
  ) => MemoizedSelector<Record<string, any>, string | undefined>;
  selectUrl: MemoizedSelector<Record<string, any>, string>;
  selectTitle: MemoizedSelector<Record<string, any>, string | undefined>;
} = getRouterSelectors();
